import React, { Component } from 'react';
import moment from "moment-timezone";

import Icon from "../icon/icon.component.jsx"


function formatEventDatesInformation(startAtDate, endAtDate, timezone) {
    const displayedTimezone = timezone || moment.tz.guess()
    const startDate = moment(startAtDate).tz(displayedTimezone).format('LL')
    const endDate = moment(endAtDate).tz(displayedTimezone).format('LL')
    const startTime = moment(startAtDate).tz(displayedTimezone).format('LT')
    const endTime = moment(endAtDate).tz(displayedTimezone).format('LT')
    const timezoneAbbr = moment.tz(displayedTimezone).zoneAbbr()

    if (startDate === endDate) {
        return `${startDate} ${startTime} - ${endTime} ${timezoneAbbr}`
    }
    return `${startDate} ${startTime} - ${endDate} ${endTime} ${timezoneAbbr}`
}

function compareByDate(a, b) {
    if (a.attributes.startAt < b.attributes.startAt) {
        return -1
    } else if (b.attributes.startAt < a.attributes.startAt) {
        return 1
    } else {
        return 0
    }
}

class GroupCalendarEventsDescription extends Component {
    render() {
        const calendarEvents = this.props.calendarEvents
        if (!calendarEvents || calendarEvents.length == 0) {
            return ''
        }

        const timezone = this.props.timezone

        return (
            <div className="row mt-2">
                {calendarEvents
                    .sort(compareByDate)
                    .map(e =>
                        <div className="col-12" key={"group-event-key-" + e.id}>
                            <p className="float-left mr-3 mb-0">
                                <Icon
                                    value={"clock"}
                                    className={'mr-2 text-secondary'}
                                />
                                {formatEventDatesInformation(e.attributes.startAt, e.attributes.endAt, timezone)}
                            </p>

                            <p className="float-left mr-3 mb-0" >
                                <Icon
                                    value={"calendar-day"}
                                    className={'mr-2 text-secondary'}
                                />
                                {e.attributes.title}
                            </p>

                            <p className="float-left mr-3 mb-0">
                                <Icon
                                    value={"home"}
                                    className={'mr-2 text-secondary'}
                                />
                                {e.attributes.location}
                            </p>
                        </div>
                    )}
            </div>
        )
    }
}


export default GroupCalendarEventsDescription


// WEBPACK FOOTER //
// ./src/common/quote/groupcalendareventsdescription.component.jsx